// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

type Doc = {
  activeElement: HTMLElement,
};

export default class FormView extends JQueryView {
  planType: string;
  autoClicked: boolean;
  doc: Doc;

  constructor(planType: string) {
    super('.new_company_vc_member_form');
    this.planType = planType;
    this.autoClicked = true;
    // $FlowFixMe
    this.doc = (document: Doc);
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: Event) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
    this.updateBasic();
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: Event) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
    }
  }

  updateBasic() {
    $('#basic_button').click();
  }
}
